import RpcControlManager from "../../rpc_control_manager"
import messageResource from "../../messageResource"

/**
 * RPC manager for reading group data
 * @param serviceName name of the RPC java service
 * @param controller group management controller
 * @param afterErrorCallback function that will be call if error on data reading occurs
 * @param afterSavingCallback function that will be call if data reading is success
 *
 *
 * @name PRODUCT_NAME (defined in constants_js.jsp)
 */
export default function GroupDataRetrieveRPCManager(serviceName, controller, afterErrorCallback, afterSavingCallback) {
    RpcControlManager.call(this);
    this.serviceName = serviceName;
    this.controller = controller;
    this.afterErrorCallback = afterErrorCallback;
    this.afterSavingCallback = afterSavingCallback;
}

GroupDataRetrieveRPCManager.prototype = new RpcControlManager();

GroupDataRetrieveRPCManager.prototype.getService = function() {
    return jsonrpc[this.serviceName];
};

GroupDataRetrieveRPCManager.prototype.getMethods = function() {
    return [this.serviceName + '.getAllGroupsWithUsers'];
};

GroupDataRetrieveRPCManager.prototype.endSavingData = function(success) {
    if (!success && this.afterErrorCallback) {
        this.afterErrorCallback();
    }
};

GroupDataRetrieveRPCManager.prototype.onDataSavingComplete = function(result) {
    this.controller.dataRetrievingCompleted(result);
    if (this.afterSavingCallback) {
        this.afterSavingCallback();
    }
};

GroupDataRetrieveRPCManager.prototype.handleNoRightsError = function(exception) {
    if (exception.name.indexOf('com.actimind.actitime.services.NoRightsForRemoteCallException') != -1) {
        alert(JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS);
        document.location.reload();
        return true;
    }
    return false;
};

GroupDataRetrieveRPCManager.prototype.handleSpecificError = function(exception) {
    if (this.afterErrorCallback) {
        this.afterErrorCallback();
    }
    if (exception.name.indexOf('com.actimind.common.services.UserGroupsDisabledException') != -1) {
        if (PRODUCT_NAME == Product.actiPLANS)
            alert(messageResource.getMessage('actiplans.user_list.js.error.user_groups_disabled'));
        else
            alert(messageResource.getMessage('userlist.js.error_ugr_disabled'));
        document.location.reload();
        return true;
    }
    if (exception.name.indexOf('com.actimind.common.services.TimeZoneGroupsDisabledException') != -1) {
        if (PRODUCT_NAME == Product.actiPLANS)
            alert(messageResource.getMessage('actiplans.user_list.js.error.time_zone_groups_disabled'));
        else
            alert(messageResource.getMessage('userlist.js.error_tzg_disabled'));
        document.location.reload();
        return true;
    }
    if (exception.name.indexOf('com.actimind.actitime.services.NoRightsToManageAccountSettings') != -1) {
        alert(messageResource.getMessage('group_management.permissions_changed'));
        document.location.reload();
        return true;
    }
    if (exception.msg.indexOf('com.actimind.common.licensing.LicenseViolatedException') !== -1) {
        alert(messageResource.getMessage('common.license_violated_exception.action_is_not_available'))
        return true
    }

    if (exception.msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
        alert(messageResource.getMessage('common.license_expired_exception.reload_page'))
        document.location.reload()
        return true
    }

    alert(messageResource.getMessage("group_management.data_read_error"));
    return true;
};

GroupDataRetrieveRPCManager.prototype.makeRemoteCall = function(callback) {
    this.getService().getAllGroupsWithUsers(callback);
};

GroupDataRetrieveRPCManager.prototype.getTimeoutMsg = function() {
    return messageResource.getMessage("common.ajax.timeout.read_data");
};


// WEBPACK FOOTER //
// ./web/js/groupManagement/rpc/group_data_retrieve_rpc_manager.js